<div class="col-md py-2 d-flex justify-content-center">
    <div class="contacto_garsan">
        <div class="row" id="encabezado_telefono_contacto"><a [href]="'tel:965658302'">96.565.83.02</a></div>
        <div class="row" id="encabezado_horario_telefono">L-V 09:00 - 15:00</div>
        <div class="row" id="encabezado_email_contacto">ddd@gar-san.com</div>
    </div>
</div>